'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _Chevron = require('../Chevron');

var _Chevron2 = _interopRequireDefault(_Chevron);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CollapsibleModule = function (_Component) {
  (0, _inherits3.default)(CollapsibleModule, _Component);

  function CollapsibleModule(props) {
    (0, _classCallCheck3.default)(this, CollapsibleModule);

    var _this = (0, _possibleConstructorReturn3.default)(this, (CollapsibleModule.__proto__ || (0, _getPrototypeOf2.default)(CollapsibleModule)).call(this, props));

    _this.getCollapsibleModuleClasses = function (open) {
      return (0, _classnames2.default)({
        'quiver-collapsible-module quiver-collapsible-module': true,
        'quiver-collapsible-module quiver-collapsible-module--open': open,
        'quiver-collapsible-module quiver-collapsible-module--closed': !open
      });
    };

    _this.handleClick = function () {
      if (_this.props.onClick) _this.props.onClick();
      _this.setState({
        open: !_this.state.open
      });
    };

    _this.state = {
      open: false
    };
    return _this;
  }

  (0, _createClass3.default)(CollapsibleModule, [{
    key: 'componentDidUpdate',
    value: function componentDidUpdate(_, prevState) {
      if (!prevState.open && this.state.open && this.props.onOpen) {
        this.props.onOpen();
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          title = _props.title,
          children = _props.children;
      var open = this.state.open;


      return _react2.default.createElement(
        'div',
        { className: this.getCollapsibleModuleClasses(open) },
        _react2.default.createElement(
          'div',
          {
            className: 'quiver-collapsible-module__header',
            onClick: this.handleClick
          },
          _react2.default.createElement(
            'div',
            { className: 'quiver-collapsible-module__header-text' },
            title
          ),
          open ? _react2.default.createElement(_Chevron2.default, { direction: 'up' }) : _react2.default.createElement(_Chevron2.default, null)
        ),
        _react2.default.createElement(
          'div',
          { className: 'quiver-collapsible-module__content' },
          children
        )
      );
    }
  }]);
  return CollapsibleModule;
}(_react.Component);

CollapsibleModule.propTypes = {
  title: _propTypes2.default.string,
  onOpen: _propTypes2.default.func,
  children: _propTypes2.default.node,
  onClick: _propTypes2.default.func
};

CollapsibleModule.defaultProps = {
  title: null,
  onOpen: null,
  children: null,
  onClick: null
};

exports.default = CollapsibleModule;


//////////////////
// WEBPACK FOOTER
// ./~/@surfline/quiver-react/dist/CollapsibleModule/CollapsibleModule.js
// module id = 563
// module chunks = 11